module.exports = __webpack_public_path__ + "static/media/mini_hulk.281bb841.png";